import React from "react";

export function WB_CoreBlockquote({}) {
    return <div className="prose prose-base">
        <blockquote>
            WB_CoreBlockquote
        </blockquote>
    </div>
}